import React from 'react';
import { Navigate } from 'react-router-dom';
import { ListingRoute } from '../../../../../models';
import BusinessInfo from '../../../common-pages/BusinessInfo';
import { TeaserPreview } from 'router/subrouters/ListingCreationWizard/common-pages/TeaserPreview';
import { StatementOfInformation } from 'router/subrouters/ListingCreationWizard/common-pages/StatementOfInformation';

export default [
  {
    path: 'business-info',
    element: BusinessInfo,
    labelId: 'businessInfoLabelId',
  },
  {
    path: 'statement-of-information',
    labelId: 'statementOfInformationLabelId',
    element: StatementOfInformation,
  },
  {
    path: 'teaser-preview',
    element: TeaserPreview,
  },
  { index: true, element: <Navigate to="business-info" replace /> },
] as Array<ListingRoute>;
